module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_BlackMatted_MockedUp.a09a1d84.jpg";